// extracted by mini-css-extract-plugin
export default {"group":"styles_group__0zyX0","tab":"styles_tab__hEFWJ","date":"styles_date__Tza3-","amount":"styles_amount__QKuJH","inner":"styles_inner__09jkG"};